export const displayTypeCva = {
  default: 'bg-secondary outline-grey-200 text-primary fill-secondary',
  outline: 'bg-white outline-grey-100 text-secondary fill-secondary',
  gray: 'bg-grey-50 outline-grey-100 text-secondary fill-secondary',
  brand: 'bg-blue-50 outline-blue-200 text-brand-secondary fill-brand-secondary',
  accent: 'bg-brand-solid outline-brand-solid text-white',
  success: 'bg-success outline-green-200 text-success-primary fill-success-primary',
  warning: 'bg-warning-primary outline-orange-dark-200 text-warning-primary fill-warning-primary',
  error: 'bg-error-primary text-error-primary outline-error-200 fill-error-primary',
  pink: 'bg-pink-50 outline-pink-200 text-pink-700 fill-pink-700',
};
